import React from "react";
import { useTranslation } from "react-i18next/";
import { StyledButton } from "@aureskonnect/react-ui";
import classnames from "classnames";
import { useSnapshot } from "valtio";

import store, {
    setCheckModificationEffect,
    setInAllPrinters,
} from "../../store";
import { store as peripheralStore } from "../../../store";

type PrinterActionColumnType = {
    element: any;
};

export function PrinterActionColumn({ element }: PrinterActionColumnType) {
    const { t } = useTranslation();
    const { printerSelected } = useSnapshot(store);
    const [isSelected, setIsSelected] = React.useState<boolean>(false);

    const { isAddPeripheralClicked } = useSnapshot(peripheralStore);

    React.useEffect(() => {
        setIsSelected(
            printerSelected.filter(
                (printer: any) => printer.Id === element["Id"]
            ).length > 0
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [printerSelected]);

    return (
        <StyledButton
            rounded
            outline
            variant={isSelected ? "danger" : "light"}
            className={classnames(
                "button-style-select___clz afa_btn_selectPeripheral cmn_icn_dissociate",
                {
                    "not-allowed-icon__clz": isAddPeripheralClicked,
                }
            )}
            onClick={() => {
                setInAllPrinters(element);
                setCheckModificationEffect(true);
            }}
        >
            <span>{isSelected ? t("Deselect") : t("Select")}</span>
        </StyledButton>
    );
}
